export default __webpack_public_path__ + "3041c4bf078d1e43cad19770803c4b8c.jpg";